// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sZ uC","ribbon":"s0 uL","title":"s1 uE","year":"s2 uF","genres":"s3 uK","duration":"s4","buttonWrapper":"s5 uG","button":"s6 uH","price":"s7","upperParts":"s8"};